import {ReactElement} from "react"
import {Button} from "antd"
import {t} from "@ui/common/intl"
import PoolModal from "@ui/components/common/PoolModal"

type TErrorModalProps = {
  show?: boolean
  onClose: () => void
}
const ErrorModal = ({show, onClose}: TErrorModalProps): ReactElement => {
  return (
    <PoolModal
      className="profile-error-modal"
      open={show}
      closable={false}
      width=""
      centered={true}
      footer={
        <div className="buttons">
          <Button className="button-primary" onClick={onClose}>
            {t("button.close")}
          </Button>
        </div>
      }
    >
      <div className="error-icon"></div>
      <div className="title">{t("profile.error.title")}</div>
      <div className="text">{t("profile.error.text")}</div>
    </PoolModal>
  )
}

export default ErrorModal
